import { toastify } from "../toast/toastify";

export const missingPopup = (field) => {
    toastify(`${field} is missing`, "error");
};
